const SETUSERAUTH = (state, fields) => {
  state.userAuth = {
    token: localStorage.getItem('token') || '',
    email: fields.email,
    idPerfil: fields.idPerfil,
    nome: fields.nome,
    id: fields.id,
    descPerfil: fields.descPerfil
  }
}

const LOGOUT = (state) => {
  state.userAuth = {
    token: '',
    email: '',
    idPerfil: '',
    nome: '',
    id: '',
    descPerfil: ''
  }
}

export default {
  SETUSERAUTH,
  LOGOUT
}
